import type { Column } from '@talos/kyoko';
import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import type { ReactNode } from 'react';
import { PRICE_GRID_MARKET_DATA_LEAF_COLUMN_PROPS } from './priceGridMarketDataColumnUtils';

/**
 * Shell for the narrow, fixed-width leaf columns that render a control for the row rather than a value
 * (RFQ button, symbol menu). Keeps the column mechanics in one place so each grid only supplies its renderer.
 */
export function getPriceGridRowActionColumn<TRow, TData>({
  colId,
  field,
  width,
  dynamics,
  cellRenderer,
}: {
  colId: string;
  field?: Column<unknown, TData>['field'];
  width: number;
  dynamics?: Column<unknown, TData>['dynamics'];
  cellRenderer: (params: ICellRendererParams<TRow, TRow>) => ReactNode;
}): Column<ColDef<TRow, TRow>, TData> {
  return {
    type: 'custom',
    id: colId,
    field,
    title: '',
    initialWidth: width,
    minWidth: width,
    maxWidth: width,
    dynamics,
    sortable: false,
    ...PRICE_GRID_MARKET_DATA_LEAF_COLUMN_PROPS,
    params: {
      colId,
      headerName: '',
      resizable: false,
      // The row is the value so an enrichment clone is a new reference and AG Grid refreshes the action cell.
      valueGetter: ({ data }) => data,
      cellRenderer,
    },
  };
}
